export const COMPANY = 'COMPANY'
export const LOADING = 'LOADING'
export const TOKEN = 'TOKEN'
export const MEMBER_PER_PAGE = 'MEMBER_PER_PAGE'
export const MEMBER_LIST = 'MEMBER_LIST'
export const MEMBER_CHANGE_POINT_RESULT = 'MEMBER_CHANGE_POINT_RESULT'
export const SEARCH_MEMBER_ONE_RESULT = 'SEARCH_MEMBER_ONE_RESULT'
export const LoginUserName = 'LoginUserName'
export const LoginUserID = 'LoginUserID'
export const FUNCTION = 'FUNCTION'
export const LOGOUT = 'LOGOUT'



// WEBPACK FOOTER //
// ./src/store/mutations_types.js